new Vue({
    el:".review",
    data(){
        return{
            navData:[
                {
                    step:1,title:'Leave a Review'
                },
                {
                    step:2,title:'Upload Screenshot'
                },
                {
                    step:3,title:'Get Verified'
                },
            ],
            prizeData:[
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3_8298eaf1-0267-48d4-a3a3-41376b02b10f.avif?v=1764815446',
                    text:'NeXLIM GO Kit *1'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/2_df76b916-1851-4835-b2be-6c76d426f860.avif?v=1764815445',
                    text:'XLIM GO 2 Kit *1'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4_9083b405-c3f4-4a48-82dc-8a9e797be6db.avif?v=1764815445',
                    text:'NeXLIM Pod Pack *1'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/1_70e6741a-a41d-4c54-8a0c-0bc6aeecf207.avif?v=1764815445',
                    text:'Xlim Pod Pack *1'
                },
            ],
            prizeIndex:0,
            navIndex:0,
            box4Swiper:null,
            //图片宽高标识 0为横图 1为竖图
            imgFlag:1,
            file:[], 
            user:{
                img:'',
                prize:'',
                name:'',
                email:'',
                phone:'',
                country:'Country',
                state:'',
                city:'',
                postal:'',
                street:''
            },
            findText:'',
            popup1:false,
            select_flag1:0,
            countryArr:[],
            filesData:[]
        }
    },
    methods:{
        nextNav(){
            if(this.user.img=='' || this.file.length==0){
                showMessage('please upload screenshot','error')
                return;
            }
            this.navIndex=2
            this.uploadImage()
        },
        //压缩图片
        compressImage(event){
            var that = this
            const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = function(e) {
                const img = new Image();
                img.src = e.target.result;

                img.onload = function() {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // 保持原始尺寸
                    canvas.width = img.width;
                    canvas.height = img.height;

                    if(img.width>img.height){
                        that.imgFlag = 0 //横图
                    }
                     

                    ctx.drawImage(img, 0, 0, img.width, img.height);

                    // 将canvas内容转为Blob对象，并设置压缩质量
                    canvas.toBlob(function(blob) {

                        // 将Blob对象转换为File对象
                        const compressedFile = new File([blob], file.name, { type: 'image/jpeg' });

                        // 输出File对象
                        //console.log(compressedFile);
                        that.file = [compressedFile]

                    }, 'image/jpeg', 0.75); // 第二个参数是图片类型，第三个参数是压缩质量
                };
            };

            reader.readAsDataURL(file);
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                    country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );
        
            if (targetCountry) {
                // 滚动到目标国家
                //targetCountry.scrollIntoView({ block: 'start' });
                // 让父容器内部滚动，而不是整个页面滚动
                countryList.scrollTop = targetCountry.offsetTop;
            }
        },
        //上传图片
        uploadFile(event){
            var file = event.target.files[0]
            if(file.size>5*1024*1024){
                showMessage('The uploaded file cannot exceed 6M','error')
                this.$refs.fileInput.value = "";
                return;
            }else{
                var that = this
                this.compressImage(event)
                const reader = new FileReader();
                reader.onload = function(e) {
                    that.user.img = e.target.result; // 将图片的 base64 数据设为 img 的 src
                    that.$refs.fileInput.value = "";
                };
                reader.readAsDataURL(file); // 读取文件数据为 Data URL
            }
        },
        async uploadImage(){
            //上传文件
            const formData = new FormData();
            formData.append("files", this.file[0]);
            let res=await axios.post('https://service.oxvatech.cn/activity/upload',formData,{headers: {
                'Content-Type': 'multipart/form-data'
            }});

            if(res.status==200){
                this.user.img = res.data.files[0].path
                this.filesData = res.data.files[0]
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async submitForm(){
            if(!this.user.name || !this.user.email || !this.user.phone || this.user.country=='Country' || !this.user.state || !this.user.city || !this.user.postal || !this.user.street){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            this.user.prize = this.prizeData[this.prizeIndex].text
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            params.append('files',JSON.stringify(this.filesData));
            let res = await axios.post('https://service.oxvatech.cn/OXVA/reviewSubmit',params);
            if(res.data.status==200){
                this.navIndex = -1
                var element = document.querySelector(".box2");
                element.scrollIntoView({block: "start",behavior: "smooth"});
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
    },
    created(){
        this.getCountry()
    },
    mounted(){
        this.box4Swiper = new Swiper('.box4Swiper', {
            autoplay: true,
            slidesPerView: 2,
            centeredSlides: true,
            pagination: {
                el: '.box4Swiper-pagination',
            },
        })

        if(window.innerWidth<750){
            ScrollTrigger.create({
                trigger:'.box1',
                start:'top top+=10%',
                end:'+=0%',
                animation:gsap.timeline()
                    .to('.box2',{marginTop:'-29rem',duration:0.5})
            })
        }
    }
})